import { Link } from 'react-router-dom';

import { Button } from '@sandtech-hub-monorepo/ui-kit';
import { FIT_HELP_CENTER_URL } from '@sandtech-hub-monorepo/ui-kit-site';

import { ReactComponent as NotFoundIllustration } from '../../assets/Icons/credential-not-found.svg';
import { AppRoutesPaths } from '../../routes/types';

interface Props {
  noun: 'badge' | 'certificate';
}

export const CredentialNotFound = ({ noun }: Props) => (
  <div className="flex flex-1 flex-col items-center gap-10 px-2 py-10 sm:px-8 lg:flex-row lg:justify-between">
    <div className="flex max-w-lg flex-col gap-12">
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-3">
          <span className="font-medium text-primary">404 error</span>
          <h1 className="text-4xl font-semibold text-heading sm:text-6xl">
            {noun === 'badge' ? 'Badge' : 'Certificate'} not found
          </h1>
        </div>
        <p className="text-lg text-muted-foreground sm:text-xl">
          We couldn't find a {noun} associated with this URL ID. Please check
          the link and try again.
        </p>
      </div>
      <div className="flex flex-wrap gap-3">
        <Button asChild className="h-12 px-5">
          <Link to={AppRoutesPaths.Home}>Take me home</Link>
        </Button>
        <Button asChild variant="outlineFg" className="h-12 px-5">
          <Link
            to={FIT_HELP_CENTER_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact support
          </Link>
        </Button>
      </div>
    </div>
    <NotFoundIllustration className="h-auto w-full max-w-2xl" />
  </div>
);
